import { jsx as _jsx } from "react/jsx-runtime";
import { QueryClient } from '@tanstack/react-query';
import { createContext, useContext, useEffect, useMemo } from 'react';
import { useOnce } from '../hooks';
import { CacheManager } from './manager';
const CacheManagerContext = createContext(null);
export function CacheManagerProvider({ children }) {
    const queryClient = useOnce(() => new QueryClient());
    const cacheManager = useMemo(() => new CacheManager(queryClient), [queryClient]);
    useEffect(() => {
        return () => {
            cacheManager.clear();
        };
    }, [cacheManager]);
    return _jsx(CacheManagerContext.Provider, { value: cacheManager, children: children });
}
export function useCacheManager() {
    const cacheManager = useContext(CacheManagerContext);
    if (!cacheManager) {
        throw new Error('CacheManagerContext not found');
    }
    return cacheManager;
}
